var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0818 3.02454C37.5592 3.02454 29.228 5.55734 22.1417 10.3026C15.0554 15.0479 9.53236 21.7926 6.2709 29.6838C3.00944 37.5749 2.15609 46.2582 3.81877 54.6354C5.48145 63.0126 9.58547 70.7075 15.6119 76.7471C21.6383 82.7868 29.3163 86.8998 37.6752 88.5661C46.034 90.2325 54.6982 89.3773 62.5721 86.1086C70.4459 82.84 77.1758 77.3048 81.9107 70.2029C86.6456 63.1011 89.1729 54.7516 89.1729 46.2102C89.1729 34.7567 84.6329 23.7722 76.5518 15.6733C68.4707 7.57445 57.5103 3.02454 46.0818 3.02454V3.02454ZM52.8857 48.0304L75.2128 60.9526L73.4057 64.122L51.0786 51.2089L63.9724 73.585L60.8009 75.3961L47.889 53.0381V78.8735H44.2747V53.0381L31.3808 75.4142L28.2093 73.6031L41.1032 51.227L18.7761 64.1401L16.9689 60.9707L39.296 48.0485H13.4722V44.381H39.2599L16.9328 31.4679L18.7399 28.2894L41.0671 41.2116L28.1912 18.8173L31.3627 17.0062L44.2747 39.3552V13.5199H47.889V39.3552L60.7738 16.9791L63.9453 18.7902L51.0514 41.1663L73.3785 28.2441L75.1857 31.4226L52.8586 44.3358H78.6373V48.0032L52.8857 48.0304Z",
    fill: "#FCBD03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.2,
    height: 89.3869,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow2);
export default __webpack_public_path__ + "static/media/snow2.7acc962adfa3eb48a437b9afe2907200.svg";
export { ForwardRef as ReactComponent };